import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {getApps, GetAppResult} from 'react-native-map-link';

import {Marker} from 'react-native-maps';

import {StationDTO} from '../../dtos/StationDTO';

import {
  Container,
  StationHeader,
  GoBackButton,
  GoBackButtonIcon,
  MarkerView,
  StationInfos,
  StationDescription,
  StationFlag,
  StationName,
  Title,
  Subtitle,
  Content,
  LocalizationList,
  Localization,
  Label,
  Local,
  MapIconButton,
  OpenMapIcons,
  MapIcon,
  MapTitle,
  OpenMapsContainer,
} from './styles';

import {useTheme} from 'styled-components/native';
import { Platform } from 'react-native';

interface Routes {
  item: StationDTO;
  rank?: 'gold' | 'silver' | undefined;
  codigo?: string;
  name?: string;
  productType?: string;
}

export function Station() {
  const route = useRoute();
  const theme = useTheme();

  const navigation = useNavigation();

  const [maps, setMaps] = useState<GetAppResult[]>([] as GetAppResult[]);

  const {item} = route.params as Routes;

  useEffect(() => {
    async function getMaps() {
      const apps = await getApps({
         appsWhiteList: ['waze', 'apple-maps', 'google-maps'],
        directionsMode: 'car',
        latitude: item.lat,
        longitude: item.lng,
      });

      setMaps(apps);
    }

    getMaps();
  }, []);

  return (
    <Container>
      <GoBackButton onPress={() => navigation.goBack()} activeOpacity={1}>
        <GoBackButtonIcon name="chevron-left" />
      </GoBackButton>
      <StationHeader
        region={{
          latitude: item.lat,
          longitude: item.lng,
          latitudeDelta: 0.0012,
          longitudeDelta: 0.0024,
        }}
        showsUserLocation
        customMapStyle={theme.mapstyle}>
       {
        Platform.OS !== "web" &&  <Marker
          key={item.name}
          coordinate={{
            latitude: item.lat,
            longitude: item.lng,
          }}
          title={item.name}>
          <MarkerView
            source={{
              uri: item.flag_image,
            }}
          />
        </Marker>
       }
      </StationHeader>

      <Content>
        <StationInfos>
          <StationDescription>
            <StationFlag source={{uri: item.flag_image}} />
            <StationName>
              <Subtitle>{item.city}</Subtitle>
              <Title>{item.name}</Title>
            </StationName>
          </StationDescription>
        </StationInfos>

        <LocalizationList>
          <Localization>
            <Label>Cidade/Estado</Label>
            <Local>
              {item.city}, {item.localidade}
            </Local>
          </Localization>
          <Localization>
            <Label>Endereço</Label>
            <Local>{item.address}</Local>
          </Localization>
          <Localization>
            <Label>Bairro</Label>
            <Local>{item.neighbourhood}</Local>
          </Localization>
          <Localization>
            <Label>CEP</Label>
            <Local>{item.cep}</Local>
          </Localization>
        </LocalizationList>

        <OpenMapsContainer>
          <OpenMapIcons>
            {maps.map(map => (
              <MapIconButton
                activeOpacity={0.7}
                onPress={map.open}
                key={map.id}>
                <MapIcon source={map.icon} />
                <MapTitle>{map.name}</MapTitle>
              </MapIconButton>
            ))}
          </OpenMapIcons>
        </OpenMapsContainer>
      </Content>
    </Container>
  );
}
